import { Link } from "react-router-dom";
import type { InboundEmail } from "@/services/inbound-email.service";
import { IGNORE_REASON_LABEL, formatEmailDate } from "./status";

/** One-line explanation of where the email is in the flow. */
export function InboxStatusNotice({ email }: { email: InboundEmail }) {
	switch (email.status) {
		case "received":
		case "processing":
			return <p className="text-sm text-muted-foreground">Waiting for the agent. The draft usually appears within a few minutes.</p>;
		case "failed":
			return <p className="text-sm text-danger">Processing failed after {email.attempts} attempt(s): {email.error}</p>;
		case "ignored":
			return (
				<p className="text-sm text-muted-foreground">
					Ignored: {IGNORE_REASON_LABEL[email.ignore_reason ?? ""] ?? email.ignore_reason}. Reprocess to draft tasks anyway.
				</p>
			);
		case "approving":
			return (
				<p className="text-sm text-primary">
					{email.approval_stale
						? "An approval started but did not finish. Check the tasks, then reject or reprocess."
						: "Approval in progress."}
				</p>
			);
		case "rejected":
			return <p className="text-sm text-muted-foreground">Rejected {formatEmailDate(email.reviewed_at)}.</p>;
		case "approved": {
			const groups = email.draft?.groups.filter((g) => g.include) ?? [];
			return (
				<div className="text-sm text-secondary">
					<p>
						{email.created_task_ids.length} task{email.created_task_ids.length === 1 ? "" : "s"} created{" "}
						{formatEmailDate(email.reviewed_at)}.
					</p>
					<ul className="mt-1 list-disc pl-5">
						{groups.map((g, i) =>
							email.created_task_ids[i] ? (
								<li key={email.created_task_ids[i]}>
									<Link className="text-primary hover:underline" to={`/tasks/${email.created_task_ids[i]}`}>
										{g.title}
									</Link>
								</li>
							) : null,
						)}
					</ul>
				</div>
			);
		}
		default:
			return null;
	}
}
